import {getIntl} from '@@/plugin-locale/localeExports';
import {LEAD_VISIBILITY_SETTINGS_PLACES} from '@/components/Kanban/VisibilitySettings/constants';
import {CUSTOMER_VISIBILITY_SETTINGS_PLACES} from '@/components/CustomerDrawer/constants';


export const FILTER_PLACES = {
  LEAD_LIST: 'LEAD_LIST',
  LEAD_BOARD: 'LEAD_BOARD',
  LEAD_PERFORMANCE_REPORT: 'LEAD_PERFORMANCE_REPORT',
  LEAD_TEAM_PERFORMANCE: 'LEAD_TEAM_PERFORMANCE',
  LEAD_FUNNEL_REPORT: 'LEAD_FUNNEL_REPORT',
  LEAD_ROI_FUNNEL_REPORT: 'LEAD_ROI_FUNNEL_REPORT',
  TEAM_VIEW_CALENDAR: 'TEAM_VIEW_CALENDAR',
  TEAM_VIEW_CALENDAR_WEEK_VIEW: 'TEAM_VIEW_CALENDAR_WEEK_VIEW',
  CALLS: 'CALLS',
  TASKS_TABLE: 'TASKS_TABLE',
  LEAD_CALL_BACK_REPORT: 'LEAD_CALL_BACK_REPORT',
  APPOINTMENTS_TABLE: 'APPOINTMENTS_TABLE',
  JOURNEY_SERVICE_REQUESTS: 'JOURNEY_SERVICE_REQUESTS',
  CUSTOMERS_LIST: 'CUSTOMERS_LIST',
  MANAGER_OVERVIEW: 'MANAGER_OVERVIEW',
  // One shared date-range slot for every /locations/:locationId/report page —
  // the branch itself is pinned by the route, and the page has no other filters.
  BRANCH_REPORT: 'BRANCH_REPORT',
}


export const FILTER_PLACE_TO_VISIBILITY_SETTINGS_MAPPING = {
  [FILTER_PLACES.LEAD_LIST]: [LEAD_VISIBILITY_SETTINGS_PLACES.LEAD_TABLE],
  [FILTER_PLACES.LEAD_BOARD]: [LEAD_VISIBILITY_SETTINGS_PLACES.LEAD_BOARD],
  [FILTER_PLACES.TEAM_VIEW_CALENDAR]: [LEAD_VISIBILITY_SETTINGS_PLACES.CALENDAR_EVENT_POPOVER, LEAD_VISIBILITY_SETTINGS_PLACES.CALENDAR_CARD],
  [FILTER_PLACES.CUSTOMERS_LIST]: [CUSTOMER_VISIBILITY_SETTINGS_PLACES.CUSTOMERS_TABLE],
}
export const VISIBILITY_SETTINGS_PLACES_TO_FILTER_PLACE_MAPPING = Object.entries(FILTER_PLACE_TO_VISIBILITY_SETTINGS_MAPPING)
  .reduce((acc, [filterPlace, visibilityPlaces]) => {
    visibilityPlaces.forEach(visibilityPlace => {
      acc[visibilityPlace] = filterPlace;
    });
    return acc;
  }, {});

export const getFilterPlacesTitle = () => {
  const intl = getIntl()
  return {
    [FILTER_PLACES.LEAD_LIST]: intl.formatMessage({
    id: 'menu.Leads',
    defaultMessage: 'leads'
  }),
    [FILTER_PLACES.LEAD_BOARD]: intl.formatMessage({
    id: 'menu.Leads',
    defaultMessage: 'leads'
  }),
    [FILTER_PLACES.LEAD_PERFORMANCE_REPORT]: intl.formatMessage({
    id: 'menu.reports.performance',
    defaultMessage: 'Performance'
  }),
    [FILTER_PLACES.LEAD_CALL_BACK_REPORT]: intl.formatMessage({
    id: 'menu.reports.callback',
    defaultMessage: 'Callback'
  }),
    [FILTER_PLACES.LEAD_FUNNEL_REPORT]: intl.formatMessage({
    id: 'menu.reports.funnel',
    defaultMessage: 'Funnel'
  }),
    [FILTER_PLACES.LEAD_TEAM_PERFORMANCE]: intl.formatMessage({
    id: 'menu.reports.teamPerformance',
    defaultMessage: 'Team Performance'
  }),
    [FILTER_PLACES.TASKS_TABLE]: intl.formatMessage({
    id: 'menu.Tasks',
    defaultMessage: 'Tasks'
  }),
    [FILTER_PLACES.LEAD_ROI_FUNNEL_REPORT]: 'Lead ROI Funnel Report',
    [FILTER_PLACES.TEAM_VIEW_CALENDAR]: intl.formatMessage({
      id: 'menu.Calendar',
      defaultMessage: 'Calendar'
    }),
    [FILTER_PLACES.CALLS]: 'Calls',
    [FILTER_PLACES.APPOINTMENTS_TABLE]: intl.formatMessage({
      id: 'menu.Appointments',
      defaultMessage: 'Appointments'
    }),
    [FILTER_PLACES.CUSTOMERS_LIST]: intl.formatMessage({
      id: 'menu.Customers',
      defaultMessage: 'Customers'
    }),
    [FILTER_PLACES.MANAGER_OVERVIEW]: intl.formatMessage({
      id: 'menu.reports.Overview',
      defaultMessage: 'Overview'
    }),
  }
}
